import { BaseQueryParams } from "../../../../Components/Core/BasePage/BaseQueryParams";
export class QueryParams extends BaseQueryParams
{
    public type?: string;
    public filter?: string;
}